module.exports = __webpack_public_path__ + "img/icons8-map-editing copy.420998d7.svg";